
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthGsTYhNKL4jsZSO9OqW8xWJLo3FijSypB5VeBqLY3XK4Meta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93UBhEDeWMqeAOjd0c1iR7UiVgEic_45dejg71ax8B5rsTUMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as _91IATA_93EvZlpz8xfP9hxf6Qk81VuJxVFeS_456l007bE8tOPHL2QMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[IATA].vue?macro=true";
import { default as _91IATA_93DqcpjLnOh2n_45DXjuRSC3hZwJPr_6vETdUKah2j2_45PdwMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[IATA].vue?macro=true";
import { default as _91IATA_93gbm7abV8GjOKql0lgEKF2QkbnlSYHtzT3FN8Ks7xP98Meta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[IATA].vue?macro=true";
import { default as _91_46_46_46slug_93UnO3nrYbwC7UWcKKehnip9ZfVTK3_45j9Iuh7GpZ5hX0oMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/subdomain/business/[...slug].vue?macro=true";
import { default as _91IATA_938ygzunQs9Mg_45YkRjrJu9dapaABKLIvCkqKzQ4EsHBzsMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[IATA].vue?macro=true";
import { default as _91product_slug_93xpBqnUUTHlhxulcA106BK9fX1agKrkjLHRNAH7hTldkMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_93Gpbax6sI1DMAvf8m_5yloQUwDWc7QqWolvOCDnImSWAMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_93tsiNNx1MmHwsHNn2QlP5ZL_45hp2htL1vyMXzQa4g6tUgMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_9373kywKoLH3oUkTu5GtX_459BNeDs5Jjjhcmicm4VZP8X4Meta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[location]/[product_slug].vue?macro=true";
import { default as component_45stubejH319LRxsLApb_45rPi2dC6MRSrnqw51QKkSPACUAxDIMeta } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@8.57.1_ioredis@_c511f8d991d5d0b77b738ecd2bf8e52c/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubejH319LRxsLApb_45rPi2dC6MRSrnqw51QKkSPACUAxDI } from "/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@8.57.1_ioredis@_c511f8d991d5d0b77b738ecd2bf8e52c/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "port-parking-IATA___en",
    path: "/port-parking/:IATA()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[IATA].vue")
  },
  {
    name: "airport-lounges-IATA___en",
    path: "/airport-lounges/:IATA()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[IATA].vue")
  },
  {
    name: "airport-parking-IATA___en",
    path: "/airport-parking/:IATA()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[IATA].vue")
  },
  {
    name: "subdomain-business-slug___en",
    path: "/subdomain/business/:slug(.*)*",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/subdomain/business/[...slug].vue")
  },
  {
    name: "airport-hotels-with-parking-IATA___en",
    path: "/airport-hotels-with-parking/:IATA()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[IATA].vue")
  },
  {
    name: "port-parking-location-product_slug___en",
    path: "/port-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[location]/[product_slug].vue")
  },
  {
    name: "airport-lounges-location-product_slug___en",
    path: "/airport-lounges/:location()/:product_slug()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[location]/[product_slug].vue")
  },
  {
    name: "airport-parking-location-product_slug___en",
    path: "/airport-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[location]/[product_slug].vue")
  },
  {
    name: "airport-hotels-with-parking-location-product_slug___en",
    path: "/airport-hotels-with-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src1485690496/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[location]/[product_slug].vue")
  },
  {
    name: component_45stubejH319LRxsLApb_45rPi2dC6MRSrnqw51QKkSPACUAxDIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubejH319LRxsLApb_45rPi2dC6MRSrnqw51QKkSPACUAxDI
  }
]